<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Repositories from "@/repositories";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "projectlist",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loading
  },
  data() {
    return {
      title: "Project List",
      items: [],
      isLoading: false,
      workorders: null,
      filter: "",
      currentPage: 1,
      perPage: null,
      sortBy: null,
      sortDesc: false,
      filterOn: [],
      repository: null,
      totalRows: 0,
      searchText: ""
    };
  },
  methods: {
    generate() {
      this.isLoading = true;
      this.repository.actions.refresh({ page: this.currentPage, pagesize: this.perPage, sort: this.sortBy, sortDesc: this.sortDesc, search: this.filter }).then((response) => {
        this.workorders = response.data.items;
      }, (error) => {
        window.console.error(error);
      }).finally(() => {
        this.isLoading = false;
      });
    },
    loadWorkOrders(ctx, callback) {
      this.repository.requestAll({ page: ctx.currentPage, pagesize: ctx.perPage, sortBy: ctx.sortBy === "" ? null : ctx.sortBy, sortDesc: ctx.sortDesc, search: this.filter }).then((response) => {
        callback(response.data.items);
        this.totalRows = response.data.totalCount;
      }, (error) => {
        window.console.error(error);
      }).finally(() => {
        this.isLoading = false;
      });
    },
  },
  created() {
    this.perPage = localStorage.getItem("workorderlist.pagesize") ?? 30;
    this.repository = Repositories.get("workorders", this.$route.params.organisationcode);
  },
  mounted() { },
  computed: {
    fields() {
      return [
        {
          key: "trackingNumber",
          sortable: true,
          label: this.$t("general.tracking")
        },
        {
          key: "name",
          sortable: true,
          label: this.$t("general.projectname")
        },
        {
          key: "clientName",
          sortable: true,
          label: this.$t("general.customername")
        },
        {
          key: "clientEmail",
          sortable: true,
          label: this.$t("general.email")
        }
      ]
    },
  },
  watch: {
    searchText() {      
      if(typeof window.LIT !== 'undefined') {
          clearTimeout(window.LIT);
      }
      window.LIT = setTimeout(() => {
        this.filter = this.searchText;
      }, 500);
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <loading :active.sync="isLoading" :can-cancel="false" color='#f1b44c' :width=70 :height=70 loader='dots'
      :is-full-page="true">
    </loading>
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <b-button variant="success" @click="generate">{{ $t("general.generate") }}</b-button>
          <div class="col-sm-12 col-md-12">
            <div id="tickets-table_filter" class="dataTables_filter text-md-right">
              <label class="d-inline-flex align-items-center">
                {{ $t('navbar.search.text') }}
                <b-form-input v-model="searchText" type="search" :placeholder='$t("navbar.search.text")'
                  class="form-control form-control-sm ml-2"></b-form-input>
              </label>
            </div>
          </div>
          <div class="mb-0">
            <b-table outlined sticky-header :fields="fields" responsive :per-page="perPage" :current-page="currentPage"
              :sort-by="sortBy" :sort-desc="sortDesc" :filter="filter" :items="loadWorkOrders" style="flex: 1 1 0; max-height: 100%; scrollbar-width: thin">
              <template #cell(trackingNumber)="data">
                <router-link
                  :to="{ name: 'workorder', params: { organisationcode: $route.params.organisationcode, trackingnumber: data.item.trackingNumber } }">{{
                    data.item.trackingNumber }}</router-link>
              </template>
            </b-table>
          </div>
          <div class="d-flex align-items-center justify-content-between">
            <!-- pagination -->
            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"
              :first-text="$t('general.first')" :prev-text="$t('general.prev')" :next-text="$t('general.next')"
              :last-text="$t('general.last')">
            </b-pagination>
            <b-form-group :label="$t('general.itemPerPage')" label-for="pagesize-input" label-cols-sm="8"
              label-align-sm="right" content-cols-sm="4" class="w-25"><b-form-select id="pagesize-input" v-model="perPage"
                :options="[30, 50, 100]" />
            </b-form-group>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
